import { ResponseArray } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import {
    CreateCustomerCredit,
    CreditService,
    CustomerCredit,
    CustomerCreditTransaction,
    UpdateCustomerCredit,
} from '../types'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import queryString from 'query-string'

export const getCustomerCredits = async ({
    customerID,
}: {
    customerID: number
}) => {
    const response = await datacentral.get<ResponseArray<CustomerCredit>>(
        `/customers/${customerID}/credits`
    )
    return response?.data
}

export const getCustomerCreditTransactions = async ({
    customerID,
    payload,
}: {
    customerID: number
    payload: DataGridPayload
}) => {
    const response = await datacentral.get<
        ResponseArray<CustomerCreditTransaction>
    >(
        `/customers/${customerID}/credits/transactions?${queryString.stringify(payload)}`
    )
    return response?.data
}

export const createCustomerCredit = async ({
    customerID,
    data,
}: {
    customerID: number
    data: CreateCustomerCredit
}) => {
    const response = await datacentral.post(
        `/customers/${customerID}/credits`,
        {
            credit_transaction: data,
        }
    )
    return response?.data
}
export const updateCustomerCredit = async ({
    customerID,
    creditID,
    data,
}: {
    customerID: number
    creditID: number
    data: UpdateCustomerCredit
}) => {
    const response = await datacentral.put(
        `/customers/${customerID}/credits/${creditID}`,
        {
            ...data,
        }
    )
    return response?.data
}

export const getCustomerServiceCredits = async ({
    customerID,
}: {
    customerID: number
}) => {
    const response = await datacentral.get<ResponseArray<CreditService>>(
        `/customers/${customerID}/credits/services`
    )
    return response?.data
}
